import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActionTabletTransportCreationProfileItemComponent } from './action-tablet-transport-creation-profile-item/component/action-tablet-transport-creation-profile-item.component';
import { CommonLayoutModule, CommonTranslationModule, CommonUIElementsModule, CommonUIFieldsModule, CommonUIDialogModule, ApplicationClientCommonModule, ActionTabletModule } from '@sdbn/common';
import { MatRippleModule } from '@angular/material/core';
import { ActionTabletTransportCreationProfileItemEntranceSelectionComponent } from './action-tablet-transport-creation-profile-item/entrance-selection/action-tablet-transport-creation-profile-item-entrance-selection.component';
import { ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    ActionTabletTransportCreationProfileItemComponent,
    ActionTabletTransportCreationProfileItemEntranceSelectionComponent
  ],
  imports: [
    CommonModule,
    CommonLayoutModule,
    CommonUIElementsModule,
    ActionTabletModule,
    MatRippleModule,
    CommonUIFieldsModule,
    CommonTranslationModule,
    CommonUIDialogModule,
    ReactiveFormsModule,
    ApplicationClientCommonModule
]
})
export class ActionTabletTransportCreationProfileModule { }
